import React from 'react';
import { Box } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShareNodes } from '@fortawesome/pro-regular-svg-icons';
import CarrierItem from './CarrierItem';
import { Campaign } from '../../types';

interface CampaignCarrierStatusProps {
  campaign: Campaign;
}

const CampaignCarrierStatus: React.FC<CampaignCarrierStatusProps> = ({
  campaign,
}) => {
  return (
    <div
      className={`carrier-status details`}
      data-testid="campaignCarrierStatus"
    >
      <div className="details-heading">
        <Box flexDirection="row" alignItems="center">
          <Box margin={{ right: 'xs' }}>
            <FontAwesomeIcon icon={faShareNodes} style={{ fontSize: '18px' }} />
          </Box>
          <Box>
            <span className="heading2">Carrier Status</span>
          </Box>
        </Box>
      </div>
      <ul className="list-unstyled campaign-operations">
        <li className="carrier-item-wrapper">
          <CarrierItem campaign={campaign} />
        </li>
      </ul>
    </div>
  );
};

export default CampaignCarrierStatus;
